import { useContext, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardContext from "../context/DashboardContext";
import InputMask from "react-input-mask";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import EditIcon from "@mui/icons-material/Edit";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { editWorker } from "../services";
import { useNavigate } from "react-router-dom";

export default function EditWorker() {
  // VALORES INICIAIS DOS ESTADOS

  // ESTADOS DA APLICAÇÃO
  const navigation = useNavigate();
  const [inputPassword, setInputPassword] = useState("");
  const [inputAdmin, setInputAdmin] = useState("");

  // IMPORTAÇÕES DO CONTEXTO

  const {
    editCpf,
    editId,
    editName,
    setEditCpf,
    setEditName,
    clientUser,
    clientPassword,
    token,
    typeClient,
  } = useContext(DashboardContext);

  // HANDLERS

  // ----- submit do formulário
  const submitNewMember = async (event) => {
    event.preventDefault();
    const worker = {
      id: editId,
      cpf: editCpf,
      nome: editName,
      senha: inputPassword,
      admin: Number(inputAdmin),
    };
    const sendData = { worker };

    if (typeClient === "cnpj") {
      sendData.user = clientUser;
      sendData.password = clientPassword;
    } else {
      sendData.token = token;
    }
    const response = await editWorker(sendData);

    if (response === true) {
      toast.success("Funcionário editado com sucesso");
      navigation("/workers");
    } else {
      toast.error("Erro Ao Editar Funcionário");
    }
  };

  // RETORNO

  return (
    <Container>
      {/* CONTAINER PRINCIPAL */}
      <CustomContainer
        style={{ padding: "32px 48px" }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minWidth: 1100,
        }}
      >
        {/* TÍTULO DA PÁGINA */}
        <Typography
          color="primary"
          component="h2"
          mb={4}
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          variant="h4"
        >
          <EditIcon fontSize="md" sx={{ mr: 1 }} />
          Editar Funcionário
        </Typography>

        {/* FORMULÁRIO DE CADASTRO */}
        <form onSubmit={submitNewMember}>
          <Stack spacing={2}>
            {/* PRIMEIRA LINHA */}
            <Stack direction="row" spacing={2}>
              {/* NOME */}
              <CustomTextField
                autoComplete="off"
                color="primary"
                label="Nome"
                name="nome"
                onChange={(event) => {
                  setEditName(event.target.value);
                }}
                required
                size="small"
                // sx={{ width: "30%" }}
                sx={{ width: "40%" }}
                type="text"
                value={editName}
                variant="outlined"
              />

              {/* CPF/CNPJ/MATRÍCULA */}

              <InputMask
                mask="999.999.999-99"
                disabled
                maskChar=" "
                onChange={(event) => {
                  setEditCpf(event.target.value);
                }}
                required
                value={editCpf}
              >
                {() => (
                  <CustomTextField
                    required
                    disabled
                    name="cpfCnpjMatricula"
                    autoComplete="off"
                    color="primary"
                    label="CPF"
                    size="small"
                    // sx={{ width: "30%" }}
                    sx={{ width: "40%" }}
                    variant="outlined"
                    type="text"
                  />
                )}
              </InputMask>
              <CustomTextField
                autoComplete="off"
                color="primary"
                label="Nova Senha"
                name="senha"
                onChange={(event) => {
                  setInputPassword(event.target.value);
                }}
                required
                size="small"
                // sx={{ width: "30%" }}
                sx={{ width: "40%" }}
                type="password"
                value={inputPassword}
                variant="outlined"
              />
              <CustomTextField
                color="primary"
                label="Acesso"
                name="admin"
                onChange={(event) => {
                  setInputAdmin(event.target.value);
                }}
                select
                size="small"
                sx={{ width: "341.33px" }}
                value={inputAdmin}
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value="2">Administrador</MenuItem>
                <MenuItem value="1">Técnico</MenuItem>
                <MenuItem value="0">Colaborador</MenuItem>
              </CustomTextField>

              {/* CARTÃO */}
              {/* <CustomTextField
                color="primary"
                label="Cartão"
                name="cartao"
                onChange={ handleTextInputsChange }
                required
                select
                size="small"
                sx={{ width: "20%" }}
                value={ formInputs.cartao }
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value="1">Imprimir</MenuItem>
                <MenuItem value="0">Não Imprimir</MenuItem>
              </CustomTextField> */}

              {/* CORTESIA */}
              {/* <CustomTextField
                color="primary"
                label="Cortesia"
                name="cortesia"
                onChange={ handleTextInputsChange }
                required
                select
                size="small"
                sx={{ width: "20%" }}
                value={ formInputs.cortesia }
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value="0">Não</MenuItem>
                <MenuItem value="1">Sim</MenuItem>
              </CustomTextField> */}
            </Stack>

            {/* BOTÃO DE SUBMIT */}
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
            >
              <CustomButton
                sx={{ width: "200px" }}
                type="submit"
                variant="contained"
              >
                Editar
              </CustomButton>
            </Box>
          </Stack>
        </form>
      </CustomContainer>
    </Container>
  );
}
